export enum Features {
  CATCH_UP_FRIDAYS = 'catch-up-fridays',
  SUMMATIVE_TEST = 'summative-test',
  ACTIVITIES = 'activity',
  QUIZMAKER = 'short-quiz',
  LESSON_PLAN = 'lesson-plan',
  UI_REVAMP = 'ui-revamp',
  CEREBRO_TEACHING_GUIDE = 'cerebro-teaching-guide',
  DLL = 'dll',
  OBJECTIVES = 'objective',
  ANNOUNCEMENT_BANNER = 'announcement-banner',
  ANALOGY = 'analogy',
  SUBJECT_EXTENSIONS = 'cross-subject-extension',
  IB_NAVBAR = 'ib-navbar',
  TOPIC_EXPLORER = 'topic-explorer',
  ENERGIZER = 'energizer',
  ELIF = 'elif',
  PHOTO_BOOTH = 'photo-booth',
  UNIT_PLAN = 'unit-plan',
  IB_SUMMATIVE_TEST = 'ib-summative-test',
  PPT_MAKER = 'ppt-maker',
}
